import $api from '../services';

export default {
    getCustomFields() {
        return $api.get('/custom-fields/unique-additional-info');
    },
    getCustomFieldsById(id) {
        return $api.get(`/custom-fields/${id}/unique-additional-info`);
    }
};
